var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "details" }, [
    _c("div", { staticClass: "nuv" }, [
      _c(
        "a",
        { staticClass: "active", attrs: { href: "/tjkStudy/examlist" } },
        [_vm._v("考试中心")]
      ),
      _vm._v(">"),
      _c("span", [_vm._v(_vm._s(_vm.data.examConfig.name))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "details-box clear" }, [
          _c("div", {
            staticClass: "zoomImage",
            style: _vm.style(_vm.data.examConfig.iconUrl)
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "txt" },
            [
              _c("h2", [_vm._v(_vm._s(_vm.data.examConfig.name))]),
              _vm._v(" "),
              _vm.data.examConfig.examType == "Formal"
                ? [
                    _c("div", { staticClass: "iconfont icon-people" }, [
                      _vm.data.examStastics != null
                        ? _c("span", [
                            _vm._v("已有"),
                            _c("i", [
                              _vm._v(_vm._s(_vm.data.examStastics.registerNum))
                            ]),
                            _vm._v("人报名")
                          ])
                        : _c("span", [
                            _vm._v("已有"),
                            _c("i", [_vm._v("0")]),
                            _vm._v("人报名")
                          ])
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "报名时间：" +
                          _vm._s(_vm.data.examConfig.regStartTime) +
                          " ~ " +
                          _vm._s(_vm.data.examConfig.regEndTime)
                      )
                    ])
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "考试时间：" +
                    _vm._s(_vm.data.examConfig.startTime) +
                    " ~ " +
                    _vm._s(_vm.data.examConfig.endTime)
                )
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _vm.data.examPaper.paperType == "Normal"
                    ? [
                        _c("span", { staticClass: "pr" }, [
                          _vm._v(
                            "总分：" +
                              _vm._s(_vm.data.examPaper.totalScore) +
                              "分"
                          )
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _vm._v("及格：" + _vm._s(_vm.data.examConfig.passScore)),
                      _vm.data.examPaper.paperType == "Normal"
                        ? [_vm._v("分")]
                        : [_vm._v("字/分")]
                    ],
                    2
                  )
                ],
                2
              ),
              _vm._v(" "),
              _vm.data.highestScoreRecord != null
                ? _c(
                    "p",
                    [
                      _vm._v(
                        "\n              我的最高纪录：" +
                          _vm._s(_vm.data.highestScoreRecord.score)
                      ),
                      _vm.data.examPaper.paperType == "Normal"
                        ? [_vm._v("分")]
                        : [_vm._v("字/分")],
                      _vm._v("("),
                      _vm.data.highestScoreRecord.isPassed == "passed"
                        ? [_vm._v("通过")]
                        : [_vm._v("未通过")],
                      _vm._v(")\n            ")
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.data.examState == "WaitingRegister"
                ? _c("div", { staticClass: "join" }, [_vm._v("报名未开始")])
                : _vm.data.examState == "WaitingCheckState"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v("已报名，等待审核")
                  ])
                : _vm.data.examState == "GoRegister"
                ? _c(
                    "div",
                    {
                      staticClass: "join",
                      on: {
                        click: function($event) {
                          return _vm.toRegister(_vm.data.examConfigId)
                        }
                      }
                    },
                    [_vm._v("立即报名")]
                  )
                : _vm.data.examState == "UnRegister"
                ? _c("div", { staticClass: "join" }, [_vm._v("报名已结束")])
                : _vm.data.examState == "WaitingExam"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v(_vm._s(_vm.data.examTypeName) + "未开始")
                  ])
                : _vm.data.examState == "GoExam"
                ? _c(
                    "div",
                    { staticClass: "join" },
                    [
                      _vm.data.examPaper.paperType == "Normal"
                        ? [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "exam",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("开始" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                        : [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "examTyping",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("开始" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                    ],
                    2
                  )
                : _vm.data.examState == "KeppingExam"
                ? _c(
                    "div",
                    { staticClass: "join" },
                    [
                      _vm.data.examPaper.paperType == "Normal"
                        ? [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "exam",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("继续" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                        : [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "examTyping",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("继续" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                    ],
                    2
                  )
                : _vm.data.examState == "WaitingReExam"
                ? _c("div", { staticClass: "join refuse" }, [
                    _vm._v(_vm._s(_vm.data.hint))
                  ])
                : _vm.data.examState == "GoReExam"
                ? _c(
                    "div",
                    { staticClass: "join" },
                    [
                      _vm.data.examPaper.paperType == "Normal"
                        ? [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "exam",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("重新" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                        : [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: {
                                    name: "examTyping",
                                    params: { id: _vm.data.examConfigId }
                                  }
                                }
                              },
                              [_vm._v("重新" + _vm._s(_vm.data.examTypeName))]
                            )
                          ]
                    ],
                    2
                  )
                : _vm.data.examState == "Examed"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v(_vm._s(_vm.data.examTypeName) + "完毕")
                  ])
                : _vm.data.examState == "OutDateExam"
                ? _c("div", { staticClass: "join" }, [
                    _vm._v(_vm._s(_vm.data.examTypeName) + "已结束")
                  ])
                : _vm.data.examState == "CheckStateUnPassed"
                ? _c("div", { staticClass: "join refuse" }, [
                    _c("p", [
                      _vm._v("审核申请被拒绝，" + _vm._s(_vm.data.hint))
                    ])
                  ])
                : _vm.data.examState == "UnableRegister"
                ? _c(
                    "div",
                    { staticClass: "join refuse" },
                    [
                      !!_vm.data.prerequisiteTodo
                        ? [
                            _vm.data.prerequisiteTodo.todoTypeName == "Course"
                              ? _c("p", [
                                  _vm._v("\n                  先去参加"),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getCourseUrl(
                                          _vm.data.prerequisiteTodo.todoId
                                        ),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.data.prerequisiteTodo.todoName
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v("课程再来报名吧\n                ")
                                ])
                              : _vm.data.prerequisiteTodo.todoTypeName ==
                                "ExamConfig"
                              ? _c("p", [
                                  _vm._v("\n                  先去参加"),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.getExamUrl(
                                          _vm.data.prerequisiteTodo.todoId
                                        ),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.data.prerequisiteTodo.todoName
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v("考试再来报名吧\n                ")
                                ])
                              : _vm._e()
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "暂时不能报名该场考试，由于需要先参加的考试或课程正在上架中，请耐心等待或联系培训老师"
                              )
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e()
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "present", attrs: { id: "present" } }, [
            _c(
              "ul",
              [
                _vm.data.examPaper.paperType == "Normal"
                  ? [
                      _c("li", [
                        _vm._v(
                          "考试总分：" +
                            _vm._s(_vm.data.examPaper.totalScore) +
                            "分"
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "li",
                  [
                    _vm._v(
                      "及格分数：" + _vm._s(_vm.data.examConfig.passScore)
                    ),
                    _vm.data.examPaper.paperType == "Normal"
                      ? [_vm._v("分")]
                      : [_vm._v("字/分")]
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.data.examConfig.maxExamTimes > 1
                  ? [
                      _c("li", [
                        _vm._v(
                          "最高可考次数：" +
                            _vm._s(_vm.data.examConfig.maxExamTimes) +
                            "次"
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _vm._v(
                          "考试间隔：" +
                            _vm._s(_vm.data.examConfig.eachExamIntervalHours) +
                            "小时"
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "考试时长：" + _vm._s(_vm.data.examConfig.duration) + "分钟"
                  )
                ]),
                _vm._v(" "),
                _vm.data.examConfig.examType == "Formal"
                  ? _c("li", [_vm._v("考试类型：正式考试")])
                  : _c("li", [_vm._v("考试类型：模拟练习")])
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-head", attrs: { href: "javascript:;" } },
            [_vm._v("考试须知")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "catalog", attrs: { id: "catalog" } }, [
            _vm.data.examConfig.description != ""
              ? _c("p", {
                  domProps: {
                    innerHTML: _vm._s(_vm.data.examConfig.description)
                  }
                })
              : _c("p", [_vm._v("暂无信息")])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cat-head" }, [
      _c("a", { staticClass: "active", attrs: { href: "#present" } }, [
        _vm._v("考试详情")
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "#catalog" } }, [_vm._v("考试须知")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f4e207", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f4e207","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/examDetail.vue
// module id = 1127
// module chunks = 0